import { render, staticRenderFns } from "./MyCheck.vue?vue&type=template&id=88cc56ce&"
import script from "./MyCheck.vue?vue&type=script&lang=js&"
export * from "./MyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports